import React from 'react';

import Header from '../../main/components/Header';
import Path from '../../path/ui/Path';
import MobileBottomBar from '../../main/components/MobileBottomBar';
import { t } from 'i18next';
import ReviewsContent from '../components/ReviewsContent';
import { useParams } from 'react-router-dom';

const Main = () => {
    const { id } = useParams();
    return (
        <div className="main_container">
            <Header />
            <Path currentPath={t('feedbacks')} />
            <ReviewsContent id={id} />
            <div className="announcement_content">
                <MobileBottomBar />
            </div>
        </div>
    );
};

export default Main;